import React, { useState } from "react";
import { FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, FormHelperText } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { isFieldRequired } from "../../../helpers";
import { CustomTooltip } from "../../../consts";

const PasswordInput = ({ label, name, value, error, touched, validationSchema, ...props }) => {
    const isRequired = validationSchema ? isFieldRequired(validationSchema, name) : false;
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    return (
        <FormControl fullWidth variant="outlined" required={isRequired}>
            <InputLabel htmlFor={name}>{label}</InputLabel>
            <OutlinedInput
                id={name}
                type={showPassword ? "text" : "password"}
                endAdornment={
                    <InputAdornment position="end">
                        <CustomTooltip title={showPassword ? "Hide Password" : "Show Password"}>
                            <IconButton
                                aria-label={`toggle ${label.toLowerCase()} visibility`}
                                onClick={togglePasswordVisibility}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </CustomTooltip>
                    </InputAdornment>
                }
                label={label}
                name={name}
                value={value}
                {...props} // Pass all additional props (onChange, onBlur, etc.)
            />
            {touched && error && <FormHelperText error>{error}</FormHelperText>}
        </FormControl>
    );
};

export default PasswordInput;